import { Section, SectionTitle } from '@/components/shared/Content';
import { Box, Flex, font } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import Image from 'next/image';
import type React from 'react';
import styled from 'styled-components';

const WhoIsThisForSection = styled(Section)``;

const TargetsContainer = styled(Flex)`
  max-width: 1000px;
  width: 75%;

  ${MEDIA_QUERIES.mobile`
      width: 85%;
      `}
`;
const TargetContainer = styled(Flex)`
  & + & {
    margin-top: 30px;
  }

  ${MEDIA_QUERIES.tabletAndDesktop`
       margin-bottom: 87px;

        & + & {
            margin-top: 0;
        }
    `}
  ${MEDIA_QUERIES.mobile`
        justifyContent:start;
    `}
`;

const TextContainer = styled(Flex)`
  justify-content: left;
  flex-direction: column;

  ${MEDIA_QUERIES.upToDesktop`
      margin-left: 20px;
  `}
  ${MEDIA_QUERIES.desktop`
    max-width: 240px;
  `}
`;

const TargetTitle = styled.h3`
  ${font('main', {
    fontSize: '26px',
    lineHeight: '3.0rem',
    fontWeight: 700,
  })};
  text-align: center;
  white-space: nowrap;

  ${MEDIA_QUERIES.mobile`
        font-size: 16px;
        text-align: left;
    `};
`;

const TargetSubtitle = styled.p`
  ${font('main', { fontSize: '17px', lineHeight: '21px', fontWeight: 400 })};
  text-align: center;

  ${MEDIA_QUERIES.mobile`
        text-align: left;
    `};
  color: #797979;
`;
interface WhoIsThisForProps {
  targets: {
    name: string;
    src: StaticImageData;
    srcMobile: StaticImageData;
    title: string;
    subtitle: string;
  }[];
  title: string;
}

export const WhoIsThisFor: React.FC<WhoIsThisForProps> = ({ title, targets }) => {
  return (
    <WhoIsThisForSection pt={[65, 130]} pb={[70, 0]}>
      <SectionTitle>{title}</SectionTitle>
      <TargetsContainer pt={[60, 77]} flexDirection={['column', 'column', 'row']} flexWrap="wrap">
        {targets.map(({ name, src, title, subtitle, srcMobile }) => (
          <TargetContainer
            key={name}
            width={[1, 1, 1 / 3]}
            flexDirection={['row', 'row ', 'column']}
            alignItems="center"
          >
            <Flex alignItems="flex-end" justifyContent="center">
              <Box display={['none', 'block', 'block']}>
                <Image src={src} width="165" height="165" alt="" />
              </Box>
            </Flex>
            <Flex alignItems="flex-end" justifyContent="center">
              <Box display={['block', 'none', 'none']}>
                <Image src={srcMobile} width="68" height="68" alt="" />
              </Box>
            </Flex>
            <TextContainer>
              <Box mt={[0, 0, 15]} mb={[0, 10, 10]}>
                <TargetTitle>{title}</TargetTitle>
              </Box>
              <Box>
                <TargetSubtitle>{subtitle}</TargetSubtitle>
              </Box>
            </TextContainer>
          </TargetContainer>
        ))}
      </TargetsContainer>
    </WhoIsThisForSection>
  );
};
